<template>
	<div class="report-wrap" :class="{'mobile': mobile}">
		<div class="report-navbar">
			<div class="align-left-navbar">
				<span @click="closeReport" class="gray material-icons">keyboard_backspace</span>
				<span>{{ $t('chat.report.report') }} {{reportdata.message ? $t('chat.report.message') : $t('chat.report.account')}}</span>
			</div>
			<div class="align-right-navbar">
				<span @click="closeReport" class="gray material-icons">clear</span>
			</div>
		</div>
		<div class="report-navbar-filler"></div>
		<div class="fetched-reasons">
			<div
				v-for="(reason, i) in reasons"
				:key="reason.id"
				class="reason-wrap"
				:class="{'margin-20': i == 0}"
			>
				<input
					v-bind:value="reason.text"
					type="radio"
					name="reasonForReport"
					:id="'radio-' + reason.id"
				/>
				<label :for="'radio-' + reason.id">
					<span></span>
					<span>{{reason.text}}</span>
				</label>
			</div>

			<div class="reason-wrap">
				<input
					v-bind:value="customReason"
					type="radio"
					name="reasonForReport"
					:id="'radio-other'"
					ref="radio-other"
				/>
				<label :for="'radio-other'">
					<span></span>
					<span>{{ $t('chat.report.stateReason') }}:</span>
				</label>
			</div>
			<textarea v-model="customReason" resize="false" @click="selectOther"></textarea>
		</div>
		<div class="button-wrap" @click="reportMessage">
			<button>{{ $t('chat.report.report') }}</button>
		</div>
	</div>
</template>

<script>
import api from "../../api";
export default {
	props: {
		reportdata: Object,
		mobile: Boolean
	},
	data() {
		return {
			reasons: [],
			selectedReason: null,
			customReason: ""
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		upload() {},
		async init() {
			// fetch preset reasons set in database
			try {
				this.startLoading();
				let res = await api.getReportReasons();
				let reasons = res.data.res.map(obj => {
					return {
						id: obj.rpr_id,
						text: obj.rpr_text
					};
				});
				this.reasons = reasons;
			} catch (error) {
				this.handleError(error);
			} finally {
				this.stopLoading();
			}
		},
		selectOther() {
			// has to be done programatically because i cant bind "for" on a non label elemnt (textarea)
			this.$refs["radio-other"].checked = true;
		},
		closeReport() {
			this.$emit("close");
		},
		async reportMessage() {
			let obj = this.getReason();
			console.log(obj);
			if (!obj.rpr_text && !obj.rpr_id) {
				this.customError(this.$t('chat.report.selectCategoryError'));
				return;
			}
			try {
				this.startLoading();

				if (this.reportdata.message) await api.reportMessage(obj);
				else await api.reportUser(obj);

				let infoText =
					this.$t('chat.report.successfullReport');
				let infoObj = {
					message: infoText
				};
				this.EventBus.$emit("info", infoObj);
			} catch (error) {
				this.handleError(error);
			} finally {
				this.closeReport();
				this.stopLoading();
			}
		},
		getReason() {
			let radio = document.getElementsByName("reasonForReport");
			let selected = null;

			for (let i = 0; i < radio.length; i++) {
				const el = radio[i];
				if (el.checked) selected = el.value;
			}
			let obj = {
				rpr_id: null,
				rpr_text: selected
			};
			if (this.reportdata.message) {
				obj.msg_id = this.reportdata.id;
			} else {
				obj.usr_id = this.reportdata.id;
			}
			for (let i = 0; i < this.reasons.length; i++) {
				const el = this.reasons[i];
				if (el.text == selected) {
					obj.rpr_id = el.id;
					obj.rpr_text = el.text;
				}
			}
			return obj;
		}
	}
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
@mixin flex-start {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
@mixin flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
@mixin flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

$report-height: 380px;
$report-width: 400px;
$report-navbar-height: 40px;

.report-wrap {
	z-index: 51;
	background-color: white;
	padding: 10px;
	height: $report-height;
	width: $report-width;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
	&.mobile {
		width: 80%;
		height: 80%;
		.reason-wrap label {
			width: 100%;
			span:last-child {
				max-width: 80%;
			}
		}
	}
}
.report-navbar-filler {
	width: 100%;
	height: calc(#{$report-navbar-height} - 10px);
}
.report-navbar {
	@include flex-between;
	position: absolute;
	padding: 0 10px;
	top: 0;
	left: 0;
	border-radius: 10px 10px 0 0;
	height: $report-navbar-height;
	width: calc(100% - 20px);
	background-color: #e3e3e3;
	.material-icons.gray {
		color: #888c8e;
		font-size: 18px;
		cursor: pointer;
	}
	.align-left-navbar {
		@include flex-center();
		span {
			margin-right: 10px;
		}
	}
	.align-right-navbar {
		@include flex-center();
	}
}
.margin-20 {
	margin-top: 20px;
}
.fetched-reasons {
	width: 100%;
	height: calc(100% - 100px);
	padding: 0 0 20px 0;
	overflow: scroll;
}
.reason-wrap {
	min-height: 30px;
	padding: 0 10px;
	@include flex-start();
	height: 40px;
	input[type="radio"] {
		margin: 0;
		height: 18px;
		width: 40px;
		display: none;
	}
	input[type="radio"]:checked + label {
		span:first-child {
			background: radial-gradient(
				circle,
				rgba(199, 199, 199, 1) 10%,
				rgba(255, 255, 255, 1) 60%
			);
		}
	}
	label {
		cursor: pointer;
		@include flex-start();
		span:first-child {
			display: inline-block;
			width: 20px;
			height: 20px;
			border-radius: 50%;
			margin-right: 12.5px;
			margin-left: 2.5px;
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
			background-color: white;
			cursor: pointer;
		}
	}
}
textarea {
	padding: 10px;
	margin-left: 50px;
	width: calc(100% - 40px - 45px);
	height: 100px;
	resize: none;
	box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
	border-radius: 10px;
	border: none;
}
.button-wrap {
	@include flex-end();
	box-sizing: border-box;
	width: 100%;
	margin-top: 10px;
	button {
		width: 110px;
		height: 35px;
		line-height: 35px;
		border: none;
		margin-right: 15px;
		background: #652d90;
		color: white;
		font-weight: 100;
		letter-spacing: 0.5px;
		font-size: 14px;
		box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
		border-radius: 100px;
	}
	button:hover {
		cursor: pointer;
	}
	button:focus {
		outline: none;
	}
}
</style>